// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumb":"BreadCrumb_BreadCrumb___fuv4","fadeInKeyframe":"BreadCrumb_fadeInKeyframe__IyJ11"};